/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

function isTwitterPost(data) {
  return data.indexOf('class="twitter-tweet"') !== -1;
}

function isInstagramPost(data) {
  return data.indexOf('class="instagram-media"') !== -1;
}


export default function LiveBlogEntry(props) {
  const { entry } = props;
  const timestamp = parseISO(entry.timestamp);
  const classes = ['liveblog-entry'];

  if (entry.data && isTwitterPost(entry.data)) {
    classes.push('liveblog-entry-twitter');
  }

  if (entry.data && isInstagramPost(entry.data)) {
    classes.push('liveblog-entry-instagram');
  }

  return (
    <div className={classes.join(' ')}>
      <div className="time-date">
        <div className="time">{format(timestamp, 'H:mm')}</div>
        <div className="date">{format(timestamp, 'MM-dd')}</div>
      </div>
      { entry.message
        && <div className="message" dangerouslySetInnerHTML={{ __html: entry.message }} />
      }
      {
        entry.data
        && <div className="data" dangerouslySetInnerHTML={{ __html: entry.data }} />
      }
    </div>
  );
}

LiveBlogEntry.propTypes = {
  entry: PropTypes.shape({
    id: PropTypes.number.isRequired,
    timestamp: PropTypes.string.isRequired,
    message: PropTypes.string,
    data: PropTypes.string,
  }).isRequired,
};
